var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8187 0.34668H14.4699C15.3515 0.34668 16.0001 0.995281 16.0001 1.87691V9.52808C16.0001 10.4097 15.3515 11.0583 14.4699 11.0583H11.4084V14.1231C11.4084 15.0048 10.7598 15.6534 9.87818 15.6534H2.22701C1.34538 15.6534 0.696777 15.0048 0.696777 14.1231V6.47196C0.696777 5.59032 1.34538 4.94172 2.22701 4.94172H5.28847V1.87691C5.28847 0.995281 5.93707 0.34668 6.8187 0.34668ZM5.28847 6.47196H2.22701V14.1231H9.87818V11.0583H6.8187C5.93707 11.0583 5.28847 10.4097 5.28847 9.52808V6.47196ZM6.81825 1.88184V9.53301H14.4694V1.88184H6.81825Z",
    fill: "#011627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b8f93992c1e2f308ff806ea338e94b52.svg";
export { ForwardRef as ReactComponent };